<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">NOTAMs</h2>
  </div>
  <div class="section__body">
    <div class="notams__container">
      <div class="notams__location_container">
        <div class="notams__location">Location: <span class="notams__text-value">{{ airport.faaId }}</span></div>
        <div class="notams__verify-text">Please verify all content below using the <a class="notams__faalink" target="_blank" href="https://notams.aim.faa.gov/notamSearch/">FAA NOTAM Search Site</a> or with a flight briefer.</div>
      </div>
      <div class="notams__countline">NOTAM count: <span class="notams__text-value">{{ getNOTAMCount() }}</span>
        <span *ngIf="getNOTAMCount() > 8" class="notams__fulllisttext"> (Partial list shown. Expand to see full list <span class="notams__urltext" (click)="showAllNotams()">HERE</span>.)</span></div>
    </div>
    <table *ngIf="getNOTAMs().length > 0; else placeholder" class="data-block data-block--lg">
      <thead>
      <tr>
        <th class="notams__column-number">Number:</th>
        <th class="notams__column-date">Start Date:<br />(UTC)</th>
        <th class="notams__column-date">End Date:<br />(UTC)</th>
        <th class="notams__column-condition">Condition:</th>
      </tr>
      </thead>
      <tbody>
      <tr class="data-block__item" *ngFor="let notam of getNOTAMs(); let i = index">
        <td class="notams__data-value-number">
          {{ notam.notamId }}
        </td>
        <td class="notams__data-value">
          {{ notam.effectiveDate | date: 'MM/dd/yyyy HHmm' }}
        </td>
        <td class="notams__data-value">
          {{ notam.expirationDate | date: 'MM/dd/yyyy HHmm' }}
        </td>
        <td class="notams__data-value-condition">
          <app-truncated-text *ngIf="notam.report" class="reviews__review-body" [text]="notam.report" [limit]="108"></app-truncated-text>
        </td>
      </tr>
      <tr *ngIf="getNOTAMCount() > 0">
        <td *ngIf="getNOTAMCount() > 8" colspan="4" class="notams__see-all-button-cell"><div class="notams__see-all-button"><a (click)="showAllNotams()" mat-button
               class="overview__action aopa-mat-btn aopa-mat-btn--filled"
               [disabled]="getNOTAMCount() == 0">
          SEE ALL {{ getNOTAMCount() }} NOTAMS
        </a></div>
        </td>
        <td *ngIf="getNOTAMCount() <= 8" colspan="4" class="notams__see-all-button-cell"><div class="notams__see-all-button"><a (click)="showAllNotams()" mat-button
                                                                                                   class="overview__action aopa-mat-btn aopa-mat-btn--filled"
                                                                                                   [disabled]="getNOTAMCount() == 0">
          SEE EXPANDED LIST
        </a></div></td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">No NOTAMs were found for {{airport.identifier}}. Please verify using the <a class="notams__faalink" target="_blank" href="https://notams.aim.faa.gov/notamSearch/">FAA NOTAM Search Site</a> or with a flight briefer.</div>
  </div>
</ng-template>
